// copied from the end of https://www.newline.co/@3nvi/centralizing-api-error-handling-in-react-apps--80296494
import { getTokenInfo } from "../AuthManager/Auth";
import { getIsCypressRunning } from "constants/constants";
import { removeKeysFromObject } from "utils/arrayUtils";
import { HeadersType, QUERY_ENDPOINTS } from "./errorManagerUtils";
import { handleErrorByCode } from "./handleErrorByCode";
import { ApolloError } from "@apollo/client";
import { Auth0ContextInterface } from "@auth0/auth0-react";

// handleError is called in useQuery, but...
// for fetch components not yet refactored to use useQuery (SyncVisibleProcessesFromMachemetry)
// we can manually call handleError (via useHandleError below)
/**
 * Handles errors based on the type of error;
 * for most errors, populates the history.location.state
 * with error info to be handled by ErrorManager
 */
export function handleError({
  err,
  navigate,
  getAccessTokenSilently,
  auth0Loading,
  reload,
  user,
  headers,
}: {
  err: ApolloError;
  navigate: any;
  getAccessTokenSilently: Auth0ContextInterface["getAccessTokenSilently"];
  auth0Loading: boolean;
  reload: any;
  user: any;
  headers: HeadersType;
}) {
  if (getIsCypressRunning()) {
    return;
  }

  const { idToken, isTokenValid, idTokenExpFormatted } = getTokenInfo();

  const code: number | undefined = (err.networkError as any)?.statusCode;

  // for network-debugger-console visibility of errors that otherwise aren't caught by consoleHistory,
  // leave these console.logs in
  console.log("%c<---ERROR INFO--->", "color: red; font-weight: bold;");
  const queryEndpoint = QUERY_ENDPOINTS?.[headers?.queryName];

  console.log(err);
  console.log("error stringified: ", JSON.stringify(err));
  console.log("error code: ", code);
  console.log(
    "more info: ",
    (err.networkError as any)?.result?.errors?.[0]?.message // graphql errors show up here
  );
  console.log(`user: ${user?.name} / name: ${user?.email}`);
  console.log(
    `"has token: ${Boolean(
      idToken
    )} / is valid: ${isTokenValid} / expiry: ${idTokenExpFormatted}`
  );
  console.log(
    `request headers: `,
    JSON.stringify(removeKeysFromObject(headers, ["query"])) // remove any "query" from headers since it's too large to log
  );
  console.log("%c</--END ERROR INFO--->", "color: red; font-weight: bold;");

  // if we're not authorized for this customer, redirect to customer tiles page
  if (JSON.stringify(err).includes("Unauthorized for customer")) {
    navigate("/");
  }

  // if we're logged out, ignore the error (no credentials = bad requests)
  if (!isTokenValid) {
    console.log("-- logged out / no token, ignoring error --");
  }
  // if there's a status code to the error message, handle it here:
  else if (!code) {
    // if (getIsConsoleHistoryEnabled()) {
    //   // if there's no code, record it in network debugger's consoleHistory
    //   const message = typeof err === "object" ? JSON.stringify(err) : err;
    //   (console as any)._collect("error", [message]);
    // }
  } else {
    handleErrorByCode({
      code,
      navigate,
      reload,
      auth0Loading,
      queryEndpoint,
      err,
      getAccessTokenSilently,
    });
  }
}
